import type {Dispatch} from 'react'

import Select from '@/components/Select/Select'
import {StopsFilter} from '@/lib/flight/types'

import style from './FilterStops.module.scss'

interface Props {
  stops: StopsFilter
  setStops: Dispatch<StopsFilter>
}

const OPTIONS = [
  {
    label: 'Any stops',
    value: StopsFilter.Any,
  },
  {
    label: 'Non-stop only',
    value: StopsFilter.NonStop,
  },
  {
    label: '1 stop or fewer',
    value: StopsFilter.OneStop,
  },
  {
    label: '2 stops or fewer',
    value: StopsFilter.TwoStops,
  },
]

export default memo<Props>(function FilterStops({stops, setStops}) {
  return (
    <Select
      className={style.Select}
      buttonProps={{className: style.Button}}
      popoverProps={{className: style.Popover}}
      label='Stop'
      options={OPTIONS}
      selectedItem={stops}
      setSelectedItem={setStops}
    />
  )
})
